import classNames from "classnames";
import IconButton from "../IconButton";

export const MobileOpenActionButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <div
      className={classNames(
        "flex items-center justify-center rounded-full transition-colors hover:bg-sys-brand-secondary-container",
        "w-10 h-10 p-0"
      )}
      onClick={onClick}
      data-testid="mobile-open-action-button"
      role="button"
    >
      <IconButton name="chevron_right" />
    </div>
  );
};
